import { render, staticRenderFns } from "./BaseTodoItem.vue?vue&type=template&id=6ef7cf61&scoped=true&"
import script from "./BaseTodoItem.vue?vue&type=script&lang=js&"
export * from "./BaseTodoItem.vue?vue&type=script&lang=js&"
import style0 from "./BaseTodoItem.vue?vue&type=style&index=0&id=6ef7cf61&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef7cf61",
  null
  
)

export default component.exports